// CLEAR_INSTANCE_DETAILS
export const CLEAR_INSTANCE_DETAILS = 'CLEAR_INSTANCE_DETAILS';

// TESTING
export const API_RESET_ALL_GEARS = 'API_RESET_ALL_GEARS';

export const API_GET_ALL_ORG_ROBOTS_REQUEST = 'API_GET_ALL_ORG_ROBOTS_REQUEST';
export const API_GET_ALL_ORG_ROBOTS_SUCCESS = 'API_GET_ALL_ORG_ROBOTS_SUCCESS';
export const API_GET_ALL_ORG_ROBOTS_FAILED = 'API_GET_ALL_ORG_ROBOTS_FAILED';

export const API_BULK_ONBOARD_ORG_ROBOT_REQUEST = 'API_BULK_ONBOARD_ORG_ROBOT_REQUEST';
export const API_BULK_ONBOARD_ORG_ROBOT_SUCCESS = 'API_BULK_ONBOARD_ORG_ROBOT_SUCCESS';
export const API_BULK_ONBOARD_ORG_ROBOT_FAILED = 'API_BULK_ONBOARD_ORG_ROBOT_FAILED';
export const API_CLEAR_BULK_ONBOARD_RESULT = 'API_CLEAR_BULK_ONBOARD_RESULT';

// Per-air_id inventory validation for the multi-robot onboarding list
export const API_VALIDATE_ROBOT_AIR_ID_REQUEST = 'API_VALIDATE_ROBOT_AIR_ID_REQUEST';
export const API_VALIDATE_ROBOT_AIR_ID_SUCCESS = 'API_VALIDATE_ROBOT_AIR_ID_SUCCESS';
export const API_VALIDATE_ROBOT_AIR_ID_FAILED = 'API_VALIDATE_ROBOT_AIR_ID_FAILED';
export const API_CLEAR_ROBOT_AIR_ID_VALIDATION = 'API_CLEAR_ROBOT_AIR_ID_VALIDATION';

export const API_UPDATE_ORG_ROBOT_REQUEST = 'API_UPDATE_ORG_ROBOT_REQUEST';
export const API_UPDATE_ORG_ROBOT_SUCCESS = 'API_UPDATE_ORG_ROBOT_SUCCESS';
export const API_UPDATE_ORG_ROBOT_FAILED = 'API_UPDATE_ORG_ROBOT_FAILED';

export const API_CREATE_SHOOT_ROBOT_REQUEST = 'API_CREATE_SHOOT_ROBOT_REQUEST';
export const API_CREATE_SHOOT_ROBOT_SUCCESS = 'API_CREATE_SHOOT_ROBOT_SUCCESS';
export const API_CREATE_SHOOT_ROBOT_FAILED = 'API_CREATE_SHOOT_ROBOT_FAILED';

export const API_GET_ALL_SHOOT_ROBOT_REQUEST = 'API_GET_ALL_SHOOT_ROBOT_REQUEST';
export const API_GET_ALL_SHOOT_ROBOT_SUCCESS = 'API_GET_ALL_SHOOT_ROBOT_SUCCESS';
export const API_GET_ALL_SHOOT_ROBOT_FAILED = 'API_GET_ALL_SHOOT_ROBOT_FAILED';

export const API_UPDATE_SHOOT_ROBOT_REQUEST = 'API_UPDATE_SHOOT_ROBOT_REQUEST'; // Update robot settings, operators, is_in_canvas
export const API_UPDATE_SHOOT_ROBOT_SUCCESS = 'API_UPDATE_SHOOT_ROBOT_SUCCESS';
export const API_UPDATE_SHOOT_ROBOT_FAILED = 'API_UPDATE_SHOOT_ROBOT_FAILED';

export const API_DELETE_SHOOT_ROBOT_REQUEST = 'API_DELETE_SHOOT_ROBOT_REQUEST';
export const API_DELETE_SHOOT_ROBOT_SUCCESS = 'API_DELETE_SHOOT_ROBOT_SUCCESS';
export const API_DELETE_SHOOT_ROBOT_FAILED = 'API_DELETE_SHOOT_ROBOT_FAILED';

export const API_CLEAR_ALL_SHOOT_ROBOTS_REQUEST = 'API_CLEAR_ALL_SHOOT_ROBOTS_REQUEST';

export const API_GET_ALL_ORG_INSTANCE_REQUEST = 'API_GET_ALL_ORG_INSTANCE_REQUEST';
export const API_GET_ALL_ORG_INSTANCE_SUCCESS = 'API_GET_ALL_ORG_INSTANCE_SUCCESS';
export const API_GET_ALL_ORG_INSTANCE_FAILED = 'API_GET_ALL_ORG_INSTANCE_FAILED';

export const API_ONBOARD_ORG_INSTANCE_REQUEST = 'API_ONBOARD_ORG_INSTANCE_REQUEST';
export const API_ONBOARD_ORG_INSTANCE_SUCCESS = 'API_ONBOARD_ORG_INSTANCE_SUCCESS';
export const API_ONBOARD_ORG_INSTANCE_FAILED = 'API_ONBOARD_ORG_INSTANCE_FAILED';

export const API_UPDATE_ORG_INSTANCE_REQUEST = 'API_UPDATE_ORG_INSTANCE_REQUEST';
export const API_UPDATE_ORG_INSTANCE_SUCCESS = 'API_UPDATE_ORG_INSTANCE_SUCCESS';
export const API_UPDATE_ORG_INSTANCE_FAILED = 'API_UPDATE_ORG_INSTANCE_FAILED';

export const API_CREATE_SHOOT_INSTANCE_REQUEST = 'API_CREATE_SHOOT_INSTANCE_REQUEST';
export const API_CREATE_SHOOT_INSTANCE_SUCCESS = 'API_CREATE_SHOOT_INSTANCE_SUCCESS';
export const API_CREATE_SHOOT_INSTANCE_FAILED = 'API_CREATE_SHOOT_INSTANCE_FAILED';

export const API_GET_ALL_SHOOT_INSTANCE_REQUEST = 'API_GET_ALL_SHOOT_INSTANCE_REQUEST';
export const API_GET_ALL_SHOOT_INSTANCE_SUCCESS = 'API_GET_ALL_SHOOT_INSTANCE_SUCCESS';
export const API_GET_ALL_SHOOT_INSTANCE_FAILED = 'API_GET_ALL_SHOOT_INSTANCE_FAILED';

export const API_UPDATE_SHOOT_INSTANCE_REQUEST = 'API_UPDATE_SHOOT_INSTANCE_REQUEST';
export const API_UPDATE_SHOOT_INSTANCE_SUCCESS = 'API_UPDATE_SHOOT_INSTANCE_SUCCESS';
export const API_UPDATE_SHOOT_INSTANCE_FAILED = 'API_UPDATE_SHOOT_INSTANCE_FAILED';

export const API_DELETE_SHOOT_INSTANCE_REQUEST = 'API_DELETE_SHOOT_INSTANCE_REQUEST';
export const API_DELETE_SHOOT_INSTANCE_SUCCESS = 'API_DELETE_SHOOT_INSTANCE_SUCCESS';
export const API_DELETE_SHOOT_INSTANCE_FAILED = 'API_DELETE_SHOOT_INSTANCE_FAILED';

export const API_GET_ALL_SHOOT_INSTANCES_LIVE_STATUS_REQUEST = 'API_GET_ALL_SHOOT_INSTANCES_LIVE_STATUS_REQUEST';
export const API_GET_ALL_SHOOT_INSTANCES_LIVE_STATUS_SUCCESS = 'API_GET_ALL_SHOOT_INSTANCES_LIVE_STATUS_SUCCESS';
export const API_GET_ALL_SHOOT_INSTANCES_LIVE_STATUS_FAILED = 'API_GET_SHOOT_INSTANCE_LIVE_STATUS_FAILED';

export const API_GET_SHOOT_INSTANCE_LIVE_STATUS_REQUEST = 'API_GET_SHOOT_INSTANCE_LIVE_STATUS_REQUEST';
export const API_GET_SHOOT_INSTANCE_LIVE_STATUS_SUCCESS = 'API_GET_SHOOT_INSTANCE_LIVE_STATUS_SUCCESS';
export const API_GET_SHOOT_INSTANCE_LIVE_STATUS_FAILED = 'API_GET_SHOOT_INSTANCE_LIVE_STATUS_FAILED';

export const API_START_SHOOT_INSTANCE_REQUEST = 'API_START_SHOOT_INSTANCE_REQUEST';
export const API_START_SHOOT_INSTANCE_SUCCESS = 'API_START_SHOOT_INSTANCE_SUCCESS';
export const API_START_SHOOT_INSTANCE_FAILED = 'API_START_SHOOT_INSTANCE_FAILED';

export const API_STOP_SHOOT_INSTANCE_REQUEST = 'API_STOP_SHOOT_INSTANCE_REQUEST';
export const API_STOP_SHOOT_INSTANCE_SUCCESS = 'API_STOP_SHOOT_INSTANCE_SUCCESS';
export const API_STOP_SHOOT_INSTANCE_FAILED = 'API_STOP_SHOOT_INSTANCE_FAILED';

export const API_UPDATE_ROBOT_ZCAM_SINGLE_SETTING_REQUEST = 'API_UPDATE_ROBOT_ZCAM_SINGLE_SETTING_REQUEST';
export const API_UPDATE_ROBOT_ZCAM_SINGLE_SETTING_SUCCESS = 'API_UPDATE_ROBOT_ZCAM_SINGLE_SETTING_SUCCESS';
export const API_UPDATE_ROBOT_ZCAM_SINGLE_SETTING_FAILED = 'API_UPDATE_ROBOT_ZCAM_SINGLE_SETTING_FAILED';

export const API_GET_INVENTORY_ON_PREM_SERVER_INFO_REQUEST = 'API_GET_INVENTORY_ON_PREM_SERVER_INFO_REQUEST';
export const API_GET_INVENTORY_ON_PREM_SERVER_INFO_SUCCESS = 'API_GET_INVENTORY_ON_PREM_SERVER_INFO_SUCCESS';
export const API_CLEAR_INVENTORY_ON_PREM_SERVER_REQUEST = 'API_CLEAR_INVENTORY_ON_PREM_SERVER_REQUEST';

export const API_ONBOARD_ORG_ON_PREM_SERVER_REQUEST = 'API_ONBOARD_ORG_ON_PREM_SERVER_REQUEST';
export const API_ONBOARD_ORG_ON_PREM_SERVER_SUCCESS = 'API_ONBOARD_ORG_ON_PREM_SERVER_SUCCESS';
export const API_ONBOARD_ORG_ON_PREM_SERVER_FAILED = 'API_ONBOARD_ORG_ON_PREM_SERVER_FAILED';

export const API_UPDATE_ORG_ON_PREM_SERVER_REQUEST = 'API_UPDATE_ORG_ON_PREM_SERVER_REQUEST';
export const API_UPDATE_ORG_ON_PREM_SERVER_SUCCESS = 'API_UPDATE_ORG_ON_PREM_SERVER_SUCCESS';
export const API_UPDATE_ORG_ON_PREM_SERVER_FAILED = 'API_UPDATE_ORG_ON_PREM_SERVER_FAILED';

export const API_GET_ALL_ORG_ON_PREM_SERVERS_REQUEST = 'API_GET_ALL_ORG_ON_PREM_SERVERS_REQUEST';
export const API_GET_ALL_ORG_ON_PREM_SERVERS_SUCCESS = 'API_GET_ALL_ORG_ON_PREM_SERVERS_SUCCESS';
export const API_GET_ALL_ORG_ON_PREM_SERVERS_FAILED = 'API_GET_ALL_ORG_ON_PREM_SERVERS_FAILED';
